<template>
  <b-card :style="cardStyles">
    <div
      class="d-flex align-items-center"
      @click="toggleCollapse"
      style="cursor: pointer"
    >
      <b-avatar
        v-if="faq.avatar"
        :src="faq.avatar"
        alt="Avatar"
        class="mr-2"
        size="lg"
        square
      />
      <div
        class="d-flex justify-content-between align-items-center flex-grow-1"
      >
        <h3 class="mb-0">{{ faq.question }}</h3>
        <feather-icon icon="ChevronDownIcon" v-if="!content_visible" />
        <feather-icon icon="ChevronUpIcon" v-else />
      </div>
    </div>
    <!-- Collapsible Content -->
    <b-collapse
      :id="parentID"
      v-model="content_visible"
      class="card-content"
      @click.stop
    >
      <b-row class="card-body">
        <b-col
          v-for="item in faq.statisticsItems"
          :key="item.icon"
          md="3"
          sm="6"
          class="mb-2 mb-md-0"
          :class="item.customClass"
        >
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar size="48" :variant="item.color">
                <feather-icon size="24" :icon="item.icon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ item.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ item.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
      <!-- Render social media buttons based on the platform -->
      <div v-if="faq.platform === 'facebook'">
        <div v-if="appid && appid.length > 0">
          <v-facebook-login
            :app-id="firstAppId"
            v-model="model"
            @sdk-init="handleSdkInit"
            @login="onLogin"
            @logout="logout"
          ></v-facebook-login>
        </div>
      </div>
      <div v-if="faq.platform === 'instagram'">
        <template v-if="instagramAccounts.length > 0">
          <div v-for="account in media" :key="account.id">
            <h5>{{ account.username }}</h5>
            <p>Followers: {{ account.followers_count }}</p>
            <!-- Add more information here as needed -->
          </div>
        </template>
        <template v-else>
          <button class="btn btn-danger" @click="loginWithInstagram">
            Continue with Instagram
          </button>
        </template>
      </div>

      <div v-else-if="faq.platform === 'linkedin'">
        <button class="btn btn-info">Continue with LinkedIn</button>
      </div>
    </b-collapse>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormInput,
  BCardText,
  BCardTitle,
  BMedia,
  BAvatar,
  BSpinner,
  BMediaAside,
  BMediaBody,
  BImg,
  BCardBody,
  BBadge,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BButton,
  BDropdown,
  BLink,
  BDropdownItem,
  BAlert,
  BCollapse,
} from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import VFacebookLogin from "vue-facebook-login-component";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    VFacebookLogin,
    BCard,
    BFormInput,
    BCardText,
    BCollapse,
    BCardBody,
    BSpinner,
    BCardTitle,
    BMedia,
    BAvatar,
    BButton,
    BMediaAside,
    BMediaBody,
    BLink,
    BBadge,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BPagination,
    BAlert,
  },
  props: {
    faq: {
      type: Object,
      required: true,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      parentID: "",
      content_visible: this.collapsed,
      cardStyles: {},
      facebookAppId: "",
      model: {},
      facebookToken: "",
      FB: {},
      beakerToken: localStorage.getItem("accessToken"),
      scope: {},
      userId: null,
      search_query: "",
      blogList: [],
      blogSidebar: {},
      facebookImage:
        "https://cdn.pixabay.com/photo/2021/08/16/08/55/facebook-6549798_1280.jpg",
      currentPage: 1,
      perPage: 1,
      rows: 140,
      name: "",
      loaderDelete: false,
      email: "",
      personalID: "",
      loading: false,
      picture: "",
      fb: null,
      message: "",
      pageid: "",
      pagePost: [],
      accounts: [],
      instagramAccounts: [],
      media: [],
      postdetails: [],
    };
  },

  created() {
    this.parentID = String(Math.floor(Math.random() * 10) + 1);
  },
  computed: {
    ...mapGetters("marketingModule", {
      appid: "appid",
      posts: "posts",
      loadingMarketing: "loading",
    }),
    firstAppId() {
      return this.appid && this.appid.length > 0 ? this.appid[2].appId : null;
    },
  },
  async mounted() {
    this.getAppIdAction();
  },
  methods: {
    ...mapActions("marketingModule", [
      "getAppIdAction",
      "getPostAction",
      "removePostAction",
    ]),
    logout() {
      window.location.reload();
    },
    handleEventClick(clickInfo) {
      window.open(clickInfo.event._def.extendedProps.link, "_blank");
    },
    toggleCollapse(event) {
      event.stopPropagation();
      this.content_visible = !this.content_visible;
    },

    handleSdkInit({ FB, scope }) {
      this.FB = FB;
      this.scope = scope;
    },

    onLogin(response) {
      this.FB.api(
        "/me/accounts",
        "GET",
        { fields: "name,access_token,id" },
        (data) => {
          this.facebookToken = data.data[0].access_token;
          this.accounts = data;
          localStorage.setItem("facebookToken", this.facebookToken);
          for (let i = 0; i < data.data.length; i++) {
            const accountId = data.data[i].id;
            this.FB.api(
              accountId + "?fields=connected_instagram_account",
              (response) => {
                if (
                  response.connected_instagram_account &&
                  response.connected_instagram_account.id
                ) {
                  const instagramAccountId =
                    response.connected_instagram_account.id;
                  this.instagramAccounts = instagramAccountId;
                  console.log(
                    "Connected Instagram Account ID:",
                    instagramAccountId
                  );
                  this.FB.api(
                    instagramAccountId +
                      "?fields=biography,followers_count,follows_count,media_count,name,username,profile_picture_url,media",
                    (responseData) => {
                      this.media = responseData;
                      console.log("Media: ", this.media);
                      this.$emit("media", this.media);
                      // for each media item or post, get the following
                      for (let i = 0; i < responseData.media.data.length; i++) {
                        let mediaCount = responseData.media.data[i].id;
                        this.FB.api(
                          mediaCount +
                            "?fields=caption,like_count,media_type,media_url,timestamp,thumbnail_url,permalink,comments_count,id,ig_id,is_comment_enabled,is_shared_to_feed,media_product_type,owner,shortcode,username,comments{username,text}",
                          (responseMedia) => {
                            this.postdetails.push(responseMedia);
                            this.$emit("postdetails", this.postdetails);
                          }
                        );
                      }
                    }
                  );
                }
              }
            );
          }
        }
      );

      this.FB.api("/me", "GET", { fields: "name" }, (data) => {
        this.userId = data;
      });
      // Set facebookLoggedIn to true
      this.$emit("facebookLoggedIn", true);
    },
    loginWithInstagram() {
      this.$emit("instagramLoggedIn", true);
    },
  },
  handleEventClick(clickInfo) {
    this.showSidebar = !this.showSidebar;
    this.selectedItem = clickInfo.event;
  },
};
</script>

<style lang="scss" scoped>
.card-content {
  padding: 1rem;
}
</style>
